import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import AlertModal from "../../../../components/alertModal/alertModal";
import CheckBox from "../../../../components/checkBox/CheckBox";
import CustomBreadcrumb from "../../../../components/customBreadcrumb/CustomBreadcrumb";
import MainLoader from "../../../../components/loading/MainLoader";
import Title from "../../../../components/title/Title";
import { IPrivilege } from "../../../../interfaces/privilege";
import { ISuccessState } from "../../../../interfaces/successState";
import {
  assignPrivilegeToExternalUser,
  getExternalUserById,
  getExternalUserRoleById,
} from "../../../../store/actions/externalUser.action";
import { IRootState } from "../../../../store/configureStore";

const AssignPrivilege = () => {
  const { userId, roleId } = useParams();

  const dispatch: any = useDispatch();
  const [assignPrivileges, setAssignPrivileges] = useState<IPrivilege[]>();
  const [isSuccess, setIsSuccess] = useState<ISuccessState | undefined>();
  const {
    rolePrivileges,
    user,
    externalUser,
    loadingRoleById,
    loadingUserById,
    loadingAssignPrivileges,
    roleDataObject,
  } = useSelector(({ externalUser, privileges }: IRootState) => ({
    rolePrivileges: externalUser.rolePrivilegeDataBundle,
    externalUser: externalUser.dataObject,
    user: privileges.dataBundleUser,
    loadingRoleById: externalUser.loadingRoleById,
    loadingUserById: externalUser.loadingDataObject,
    loadingAssignPrivileges: privileges.loadingAssignPrivileges,
    roleDataObject: externalUser.roleDataObject,
  }));

  useEffect(() => {
    if (roleId) {
      dispatch(getExternalUserRoleById(+roleId));
    }

    if (userId && user) {
      dispatch(getExternalUserById(+userId, user?.id));
    }
  }, [dispatch, roleId, user, userId]);

  useEffect(() => {
    setAssignPrivileges(externalUser?.privileges);
  }, [externalUser]);

  const handleChange = (code: string) => (event: any) => {
    if (event.target.checked) {
      setAssignPrivileges((prevState) => {
        if (!prevState) {
          return [];
        }
        return [...prevState, rolePrivileges.filter((s) => s.code === code)[0]];
      });
    } else {
      setAssignPrivileges((preState) => {
        if (!preState) {
          return [];
        }

        return preState?.filter((s) => s.code !== code);
      });
    }
  };

  const handleSubmit = () => {
    if (!userId || !assignPrivileges) {
      return;
    }

    dispatch(
      assignPrivilegeToExternalUser(
        userId,
        assignPrivileges,
        setAssignPrivileges,
        setIsSuccess
      )
    );
  };

  return (
    <div className="page-container">
      <MainLoader
        show={loadingRoleById || loadingUserById || loadingAssignPrivileges}
      />
      <CustomBreadcrumb
        items={[
          { path: "/", title: "Home" },
          { path: "/settings/users", title: "Manage Users" },
          { path: "/settings/users/", title: "Assign Privileges" },
        ]}
      />

      <Title>Assigned Privilages - {externalUser?.name}</Title>

      <Row className="mt-4 row-cols-1 row-cols-md-3 gy-2 gy-md-3">
        {rolePrivileges
          ?.sort((a, b) => a.code.localeCompare(b.code))
          .map((data: IPrivilege, index) => (
            <Col key={index}>
              <CheckBox
                checked={
                  assignPrivileges
                    ?.map((item: IPrivilege) => {
                      return item["code"];
                    })
                    .includes(data.code) || false
                }
                disabled={roleDataObject?.code === "USER_ADMIN"}
                label={data.name.toUpperCase()}
                onChange={handleChange(data.code)}
              />
            </Col>
          ))}
      </Row>
      {roleDataObject?.code !== "USER_ADMIN" && (
        <Row className="mt-5 justify-content-center">
          <Col className="col-md-3">
            <Button
              className="w-100"
              variant="success"
              onClick={() => handleSubmit()}
            >
              Submit
            </Button>
          </Col>
        </Row>
      )}

      <AlertModal
        show={!!isSuccess}
        variant={isSuccess?.isSuccess ? "success" : "error"}
        buttons={[
          {
            text: "OK",
            onClick: () => setIsSuccess(undefined),
            variant: "success",
          },
        ]}
      >
        {isSuccess?.message}
      </AlertModal>
    </div>
  );
};

export default AssignPrivilege;
